import { NotifyHelper } from "../../../helpers/toast";
import { eThuPhiTamThuActionsObj } from "../../action-types/thu-phi-tam-thu/IThuPhiTamThuActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const thuPhiTamThuActions = {
  ...generateActions(eThuPhiTamThuActionsObj, "THU_PHI_TAM_THU"),
  ...generateActionForKey(
    eThuPhiTamThuActionsObj,
    "THU_PHI_TAM_THU",
    "CREATE_BIENLAITHU_SUCCESS",
    () => {
      NotifyHelper.Success("Đã tạo biên lai");
    }
  ),
  ...generateActionForKey(
    eThuPhiTamThuActionsObj,
    "THU_PHI_TAM_THU",
    "CREATE_BIENLAITHU_ERROR",
    (m) => {
      NotifyHelper.Error(m.data);
    }
  ),
  ...generateActionForKey(
    eThuPhiTamThuActionsObj,
    "THU_PHI_TAM_THU",
    "ADD_NEW_TAB_BY_ID_ERROR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
};
